export enum DropdownOpened {
  chat = 'chat',
  menu = 'menu',
}
